import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SelectInput from "../../SelectInput/index";
import { cloneDeep, isEqual } from 'lodash';
import { updateConfig } from "@/api/configurationlist";
export default {
  props: ['IpList', "deviceDid", "deviceSn"],
  components: {
    SelectInput: SelectInput
  },
  data: function data() {
    return {
      dialogVisible: false,
      SNAT: {
        enabled: false,
        name: '',
        proto: '',
        src: '',
        src_ip: '',
        src_dip: '',
        dest_ip: '',
        dest: '',
        extra: ''
      },
      protoOptions: [{
        value: "TCP",
        label: this.$t("lang.ConfigSetting.TCP")
      }, {
        value: "UDP",
        label: this.$t("lang.ConfigSetting.UDP")
      }, {
        value: "tcp udp",
        label: this.$t("lang.ConfigSetting.TCP_UDP")
      }, {
        value: "ICMP",
        label: this.$t("lang.ConfigSetting.ICMP")
      }, {
        value: "all",
        label: 'All protocals'
      }, {
        value: this.$t("lang.ConfigSetting.custom"),
        label: this.$t("lang.ConfigSetting.custom")
      }],
      SRCOptions: [{
        value: "wan",
        label: "wan"
      }, {
        value: "lan",
        label: "lan"
      }, {
        value: "",
        label: this.$t("lang.ConfigSetting.anyoneDest")
      }],
      index: 0,
      protoCustom: false,
      // 自定义proto
      originalData: {}
    };
  },
  methods: {
    show: function show(item, index) {
      this.dialogVisible = true;
      this.index = index;
      this.SNAT = cloneDeep(item.options);
      this.originalData = cloneDeep(this.SNAT);
      console.log(this.SNAT);
    },
    // 获取下拉框返回的值并更新到通信规则相应的数据中。
    IpSelectInput: function IpSelectInput(props, index) {
      this.SNAT["".concat(index[0])] = props;
    },
    // 协议选择发生变化
    protoChange: function protoChange(value) {
      var _this = this;

      if (value === this.$t("lang.ConfigSetting.custom")) {
        this.protoCustom = true;
        this.$nextTick(function () {
          _this.$refs.proto.focus();
        });
      } else {
        this.protoCustom = false;
      }
    },
    // 协议输入框失去焦点
    protoBlur: function protoBlur() {
      this.protoCustom = false;
    },
    //启用禁用
    OnOff: function OnOff() {
      this.SNAT.enabled = this.SNAT.enabled == '' ? true : false;
    },
    editRedirect: function editRedirect() {
      var _this2 = this;

      if (!isEqual(this.originalData, this.SNAT)) {
        // 0是禁用，其他的是开启
        var dataCopy = cloneDeep(this.SNAT);
        dataCopy.enabled = dataCopy.enabled == true ? '1' : '0';
        var data = [{
          section: "redirect",
          config: "firewall",
          action: 0,
          index: [this.index],
          server: "firewall",
          options: _objectSpread({}, dataCopy)
        }];
        updateConfig(this.deviceSn, this.deviceDid, data).then(function (res) {
          if (res.data.data.mess === 0) {
            _this2.$message({
              showClose: true,
              message: _this2.$t('lang.ConfigSetting.Successfulconfiguration'),
              type: 'success'
            });

            _this2.$emit('updateData');

            _this2.dialogVisible = false;
          } else {
            _this2.$message({
              showClose: true,
              message: _this2.$t('lang.ConfigSetting.Configurationerror'),
              type: 'warning'
            });
          }
        });
      } else {
        this.dialogVisible = false;
      }
    }
  }
};